import { render, staticRenderFns } from "./AxPushNotificationsAllWorkspaces.vue?vue&type=template&id=e3ed6216&"
import script from "./AxPushNotificationsAllWorkspaces.vue?vue&type=script&lang=ts&"
export * from "./AxPushNotificationsAllWorkspaces.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports